import { render } from "./simulation.vue?vue&type=template&id=1b4856ae&scoped=true"
import script from "./simulation.vue?vue&type=script&lang=js"
export * from "./simulation.vue?vue&type=script&lang=js"

import "./simulation.vue?vue&type=style&index=0&id=1b4856ae&lang=stylus&scoped=true"

import exportComponent from "/root/workspace/youyi_1_tob-teacher-fe_Ff2X/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b4856ae"]])

export default __exports__